import { StateCreator } from 'zustand';

enum ReservationDeviceOrigin {
  App = 'APP',
  Web = 'WEB',
}

interface CommonStoreHandlers {
  updateHealthcareService: (value: string) => void;
  updateLocation: (value: string) => void;
  updateChannel: (value: ReservationDeviceOrigin) => void;
  updateHeaderVersion: (value: 'old' | undefined) => void;
}

interface CommonFields {
  searchForm: {
    healthcareService: string | null;
    location: string | null;
  };
  channel: ReservationDeviceOrigin;
  headerVersion: 'old' | undefined;
}

export interface CommonState extends CommonStoreHandlers, CommonFields {}

export const createCommonSlice: StateCreator<CommonState, [], [], CommonState> = set => ({
  searchForm: {
    healthcareService: null,
    location: null,
  },
  headerVersion: undefined,
  channel: ReservationDeviceOrigin.Web,
  updateHealthcareService: (value: string): void =>
    set(state => {
      return {
        searchForm: {
          ...state.searchForm,
          healthcareService: value,
        },
      };
    }),
  updateHeaderVersion: (value: 'old' | undefined): void => set({ headerVersion: value }),
  updateLocation: (value: string): void =>
    set(state => {
      return {
        searchForm: {
          ...state.searchForm,
          location: value,
        },
      };
    }),
  updateChannel: (value: ReservationDeviceOrigin): void => set({ channel: value }),
});
